///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../../../common/security.keys.ts"/>

///<reference path="../collections/report-inventory-returns.collection.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../collection-population-strategies/inventory-returns-to-distributor.strategy.ts"/>
///<reference path="report-distributor.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    //
    export class ReportDistributorInventoryReturnsDataTemplate extends ReportDistributorDataTemplate implements IDataTemplate {

        protected inventoryReturns: ReportInventoryReturnsCollection;

        constructor(model: Dictionary<any>, properties: string[], {criteria}) {
            super(model, properties, {criteria});

            this.inventoryReturns = new ReportInventoryReturnsCollection(this.model[properties[1]], [], {
                criteria,
                idKey: 'inventoryReturnHeader_LId',
                displayNameKey: 'inventoryReturnDisplayName'
            });

            this.inventoryReturns.setParentCollection(this.distributors, InventoryReturnsToDistributorStrategy);

            this.title = 'HERO_SUB_INVENTORY_RETURNS';
            this.allSelectedLabel = 'LABEL_REPORT_INVENTORY_RETURN_ALL_RETURNS';
            this.totalSelectedMessage = 'LABEL_INVENTORY_RETURNS_SELECTED';
        }

        setWatchers(scope: angular.IScope) {
            this.inventoryReturns.setWatchers(scope);

            super.setWatchers(scope);
        }

        onCriteriaUpdate(newCriteria: { InventoryReturnsEndDate: Date; InventoryReturnsStartDate: Date; }, $q: ng.IQService): ng.IPromise<any> {
            this.inventoryReturns.updateCriteria(newCriteria);
            return this.inventoryReturns.fetch();
        }
    }
}
